import SwiperCarousel from "../../../src/scripts/components/swiper/index";

import getNearestPlaces from "../../../src/scripts/components/geolocation/index";

//MAPBOX Components
import cardHTML from "../../../src/scripts/components/mapbox/cardHTML";
import popupHTML from "../../../src/scripts/components/mapbox/popupHTML";

console.log("Script Loaded");

const { mapboxgl, LngLat, MapboxGeocoder } = window._mapbox;
const _ = window._lodash;

mapboxgl.accessToken = "pk.eyJ1IjoiaW5kdXN0cmlvdXMiLCJhIjoiY2xjcnRtajA5MGpoaDNuazZrdmxxdzY2bSJ9.L1eb2m-ZarARv36rKMgxcQ";
const induMap = {
    init() {
        this.variables();

        if (document.querySelector(`#${this.container}`)) {
            this.initMap();
            _.delay(
                () => {
                    this.addControl();
                    this.addGeocoder();
                },
                1,
                false
            );

            _.delay(() => {
                this.getData(() => {
                    if (this.map.loaded()) {
                        this.convertData();
                        this.addSource();
                        _.delay(
                            () => {
                                this.addCluster();
                                this.addPoint();
                                this.addEvents();
                                this.insertBoxes(false);
                            },
                            1,
                            false
                        );
                    } else {
                        this.map.on("load", () => {
                            this.convertData();
                            this.addSource();
                            _.delay(
                                () => {
                                    this.addCluster();
                                    this.addPoint();
                                    this.addEvents();
                                    this.insertBoxes(false);
                                },
                                200,
                                false
                            );
                        });
                    }
                });
            }, 2);
        }
    },

    /**
     * Get Variables
     */
    variables() {
        //Elements
        this.body = document.querySelector("body");
        this.closeFullMap = document.querySelector(".js-close-full-map");
        this.errorElement = document.querySelector(".js-info-block");
        this.countLocations = document.querySelector(".js-count-locations");

        //Selectors
        this.container = "map";
        this.selectorLocation = ".js-map-wrapper-locations .location-marker-til";

        //Variables
        this.icon = window.location.origin + "/wp-content/themes/industrious-theme/icons/map-pin.png";
        this.inBoundsLocations = [];
        this.array = [];
        this.html = "";
        this.full = false;

        //CSS Classes
        this.class = "d-none";
        this.toggleClass = "full-map-open";
    },

    /**
     * Get locations from localization.json
     * @param {function} call
     */
    getData(call) {
        const $this = this;

        if (typeof marketLocations != "undefined" && marketLocations) {
            const SortedMarketLocations = [];

            const order = ["signed", "opening soon", "launch_phase_2", "open"];

            order.forEach((status) => {
                marketLocations.forEach((location) => {
                    if (status == location.status) {
                        SortedMarketLocations.push(location);
                    }
                });
            });

            $this.data = SortedMarketLocations;
            $this.market = true;

            console.log("getData");

            _.delay(
                () => {
                    call();
                },
                100,
                false
            );
        } else {
            getNearestPlaces().then((places) => {
                const marketID = places.markets[0].id;
                const url = `${window.location.origin}/wp-json/v2/locations/?market_id=${marketID}&all_data=1`;

                console.log("getData2");

                fetch(url)
                    .then((response) => response.json())
                    .then((data) => {
                        $this.data = data;
                    })
                    // .then(() => {
                    //     _.delay(
                    //         () => {
                    //             console.log("call1");
                    //             call();
                    //         },
                    //         100,
                    //         false
                    //     );
                    // })
                    .then(() => {
                        const url2 = `${window.location.origin}/wp-json/v2/locations?all_data=1`;
                        _.delay(
                            () => {
                                fetch(url2)
                                    .then((response) => response.json())
                                    .then((data) => {
                                        $this.data = data;
                                    })
                                    .then(() => {
                                        _.delay(
                                            () => {
                                                console.log("call2");
                                                call();
                                            },
                                            1,
                                            false
                                        );
                                    });
                            },
                            1,
                            false
                        );
                    });
            });

            // setInterval(() => {

            // });
            // $.getJSON(
            //   window.location.origin +
            //   "/wp-content/themes/industrious-theme/localization.json",
            //   function ( data ) {
            //     $this.data = data;

            //     if(typeof pin_locations != 'undefined' && pin_locations) {
            //       $this.data = $this.filterLocations(pin_locations, data);
            //     }

            //     _.delay( () => {
            //       call();
            //     }, 100, false );
            //   }
            // );
        }
    },

    filterLocations($pinLocations, $locations) {
        const $ids = [];

        $pinLocations.forEach((location) => $ids.push(location.ID));

        $locations.forEach((location, index) => {
            if ($ids.indexOf(location.ID) > -1) {
                $locations.splice(index, 1);
            }
        });

        let $locations_ = [...$pinLocations, ...$locations];

        return $locations_;
    },

    getLockCords(locations) {
        let cords = [];
        const lat = [];
        const long = [];

        if (typeof offsetLong === "undefined") {
            var offsetLong = window.offsetLong;
        }

        if (typeof offsetLat === "undefined") {
            var offsetLat = window.offsetLat;
        }

        if (locations) {
            locations.forEach((element) => {
                lat.push(Number(element.latitude));
                long.push(Number(element.longitude));
            });

            const minLat = _.min(lat);
            const maxLat = _.max(lat);
            const maxLong = _.max(long);
            const minLong = _.min(long);

            cords = [
                [minLong - offsetLong, minLat - offsetLat],
                [maxLong + offsetLong, maxLat + offsetLat],
            ];
        }

        return cords;
    },

    /**
     * Init Map
     */
    initMap() {
        let bounds = false;

        if (typeof lock !== "undefined") {
            bounds = this.getLockCords(marketLocations);
        }

        this.map = new mapboxgl.Map({
            container: "map",
            style: "mapbox://styles/mapbox/light-v10",
            center: [-96, 37.8],
            zoom: 3,
            maxBounds: bounds,
        });

        if (typeof lock !== undefined) {
            this.map.scrollZoom.disable();
        }

        // disable map rotation using right click + drag
        this.map.dragRotate.disable();

        // disable map rotation using touch rotation gesture
        this.map.touchZoomRotate.disableRotation();

        if (typeof lock == "undefined") {
            this.centerMap();
        }
    },

    /**
     * Add Markers to MAP
     * @required this.data
     */
    addMarkers() {
        // add markers to map
        for (const location of this.data) {
            // create a HTML element for each feature
            const el = document.createElement("div");
            el.className = "marker";
            el.style.backgroundImage = `url(${this.icon})`;

            if (!location.latitude || !location.longitude) {
                console.error(`${location.location_title} has wrong co-ordinates`);
            } else {
                const cord = new LngLat(location.longitude, location.latitude);
                // make a marker for each feature and add to the map
                new mapboxgl.Marker(el).setLngLat(cord.toArray()).addTo(this.map);
            }
        }
    },

    /**
     * Add Cluster
     */
    addCluster() {
        if (!this.map.getLayer("clusters")) {
            this.clouser = this.map.addLayer({
                id: "clusters",
                type: "circle",
                source: "locations",
                filter: ["has", "point_count"],
                paint: {
                    // Use step expressions (https://docs.mapbox.com/mapbox-gl-js/style-spec/#expressions-step)
                    // with three steps to implement three types of circles:
                    //   * Blue, 20px circles when point count is less than 100
                    //   * Yellow, 30px circles when point count is between 100 and 750
                    //   * Pink, 40px circles when point count is greater than or equal to 750
                    "circle-color": ["step", ["get", "point_count"], "#013e3f", 0, "#013e3f", 20, "#013e3f"],
                    "circle-radius": [
                        "step",
                        ["get", "point_count"],
                        15, // def size
                        10, // num
                        20, // size
                        20, // num
                        25, // size
                        30, // num
                        30, // size
                    ],
                },
            });

            this.map.addLayer({
                id: "cluster-count",
                type: "symbol",
                source: "locations",
                filter: ["has", "point_count"],
                layout: {
                    "text-field": "{point_count_abbreviated}",
                    "text-font": ["DIN Offc Pro Medium", "Arial Unicode MS Bold"],
                    "text-size": 12,
                },
                paint: {
                    "text-color": "#fff",
                },
            });
        }
    },

    /**
     * Add Point without closer
     */
    addPoint() {
        /**
         * Icon
         *
         * Inside this function need 2 be `const point` to work
         */
        // this.map.loadImage( this.icon, ( error, image ) => {
        //   if ( error ) throw error;
        //   this.map.addImage( 'map-icon', image, {
        //     width: 34,
        //     height: 34,
        //   } );
        // } );
        if (!this.map.getLayer("unclustered-point")) {
            const points = this.map.addLayer({
                id: "unclustered-point",
                type: "circle",
                //type: 'symbol', // For Icon
                source: "locations",
                filter: ["!", ["has", "point_count"]],
                // layout: { // For Icon
                //   'icon-image': 'map-icon'
                // },
                paint: {
                    "circle-radius": 8,
                    "circle-color": "#013e3f",
                },
            });
        }
    },

    /**
     * Add Events
     */
    addEvents() {
        this.map.on("click", "clusters", (e) => {
            const features = this.map.queryRenderedFeatures(e.point, {
                layers: ["clusters"],
            });
            const clusterId = features[0].properties.cluster_id;
            this.map.getSource("locations").getClusterExpansionZoom(clusterId, (err, zoom) => {
                if (err) return;

                this.map.flyTo({
                    center: features[0].geometry.coordinates,
                    zoom: zoom + 1,
                });
            });
        });

        this.map.on("click", "unclustered-point", (e) => {
            const coordinates = e.features[0].geometry.coordinates.slice();
            const center = e.features[0].geometry.coordinates;

            if (window.innerWidth < 1024) {
                this.full = false;
                this.toggleFullMap();

                _.delay(
                    () => {
                        center[1] += 0.0095;

                        this.map.flyTo({
                            center: center,
                            zoom: 13,
                        });
                    },
                    100,
                    false
                );
            } else {
                center[1] += 0.008;

                this.map.flyTo({
                    center: center,
                    zoom: 13,
                });
            }

            // Ensure that if the map is zoomed out such that
            // multiple copies of the feature are visible, the
            // popup appears over the copy being pointed to.
            while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
            }

            this.marker = new mapboxgl.Popup({
                anchor: "bottom",
            })
                .setLngLat(coordinates)
                .setHTML(popupHTML(e.features[0].properties.location))
                .setOffset(10)
                .addTo(this.map);

            SwiperCarousel.init();
            this.loadImages();
        });

        this.map.on("moveend", () => {
            this.updateView();

            window.scrollTo(0, 0);
        });

        this.map.on("zoomend", () => {
            this.updateView();
        });

        this.closeFullMap.addEventListener("click", () => {
            this.toggleFullMap();
            const center = [this.map.getCenter().lng, this.map.getCenter().lat];

            _.delay(
                () => {
                    center[1] -= 0.01;

                    this.map.flyTo({
                        center: center,
                    });

                    this.marker && this.marker.remove();
                    this.marker = false;
                },
                100,
                false
            );
        });
    },

    /**
     * Toggle full view map mode
     */
    toggleFullMap() {
        this.full ? this.body.classList.remove(this.toggleClass) : this.body.classList.add(this.toggleClass);
        this.full = !this.full;

        this.map.resize();
    },

    /**
     * Get location from Features
     */
    getLocation(id = false, item) {
        const clusterId = id ? id : item.properties.cluster_id;
        if (clusterId) {
            this.map.getSource("locations").getClusterChildren(clusterId, (error, features) => {
                if (!error) {
                    features.forEach((item) => {
                        if (item.properties.cluster_id) {
                            this.getLocation(item.properties.cluster_id, item);
                        } else {
                            const location = item.properties.location.ID;

                            if (this.array.indexOf(location) === -1) {
                                this.array.push(location);
                            }
                        }
                    });
                }
            });
        } else {
            this.array.push(JSON.parse(item.properties.location).ID);
        }

        return this.array;
    },

    /**
     * Get Locations in Bounds
     */
    getLocationsInBounds() {
        const $this = this;

        $this.array = [];

        const items = $this.map.queryRenderedFeatures({
            layers: ["clusters", "unclustered-point"],
        });

        var bar = new Promise((resolve, reject) => {
            if (!items.length) {
                setTimeout(() => {
                    resolve();
                }, 100);
            } else {
                items.forEach((item, index, array) => {
                    $this.getLocation(false, item);
                    if (index === array.length - 1) {
                        setTimeout(() => {
                            resolve();
                        }, 100);
                    }
                });
            }
        });

        bar.then(() => {
            $this.inBoundsLocations = $this.array;
        }).then(() => {
            setTimeout(() => {
                $this.toggleVisibleLocations();
                $this.updateCount();
            }, 200);
        });
    },

    //https://docs.mapbox.com/mapbox-gl-js/example/filter-features-within-map-view/

    /**
     * Convert data
     */
    convertData() {
        this.locationsData = {
            type: "FeatureCollection",
            features: [],
        };

        this.data.forEach((location) => {
            const locationData = new Object();

            locationData.type = "Feature";
            locationData.id = location.ID;

            locationData.properties = {
                location: location,
            };

            locationData.geometry = {
                id: location.ID,
                type: "Point",
                coordinates: [location.longitude, location.latitude],
            };

            this.locationsData.features.push(locationData);
        });
    },

    /**
     * Add Source
     */
    addSource() {
        if (!this.map.getSource("locations")) {
            this.map.addSource("locations", {
                type: "geojson",
                // Point to GeoJSON data. This example visualizes all M1.0+ earthquakes
                // from 12/22/15 to 1/21/16 as logged by USGS' Earthquake hazards program.
                data: this.locationsData,
                cluster: true,
                clusterMaxZoom: 14, // Max zoom to cluster points on
                clusterRadius: 30, // Radius of each cluster when clustering points (defaults to 50)
            });
        } else {
            this.map.getSource("locations").setData(this.locationsData);
        }
    },

    /**
     * Add Geocoder
     */

    addGeocoder() {
        const geocoderElem = document.querySelector(".js-geocoder");
        const geocoderMobileElem = document.querySelector(".js-geocoder-mobile");

        if (geocoderElem) {
            // Add the control to the map.
            const geocoder = new MapboxGeocoder({
                accessToken: mapboxgl.accessToken,
                mapboxgl: mapboxgl,
                placeholder: window.translate.map_placeholder,
                marker: false,
            });

            geocoderElem.appendChild(geocoder.onAdd(this.map));
        }

        if (geocoderMobileElem) {
            const geocoderMobile = new MapboxGeocoder({
                accessToken: mapboxgl.accessToken,
                mapboxgl: mapboxgl,
                placeholder: window.translate.map_placeholder,
                marker: false,
            });

            geocoderMobileElem.appendChild(geocoderMobile.onAdd(this.map));
        }
    },

    /**
     * Update View
     */
    updateView() {
        this.getLocationsInBounds();
    },

    /**
     * Toggle Visible
     */

    toggleVisibleLocations() {
        this.locations_ = document.querySelectorAll(`${this.selectorLocation}:not(.d-none)`);
        this.visible = false;

        this.locations_ &&
            this.locations_.forEach((location) => {
                if (_.indexOf(this.inBoundsLocations, Number(location.dataset.markerId)) > -1) {
                    //location.classList.remove(this.class);
                    this.visible = true;
                } else {
                    location.classList.add(this.class);
                }
            });

        this.inBoundsLocations &&
            this.inBoundsLocations.forEach((id) => {
                const location = document.querySelector(`${this.selectorLocation}[data-marker-id="${id}"]`);
                location && location.classList.remove(this.class);
                this.visible = true;
            });

        _.delay(
            () => {
                this.visible ? this.errorElement.classList.add(this.class) : this.errorElement.classList.remove(this.class);
            },
            1000,
            false
        );
    },

    /**
     * Insert boxes
     */
    insertBoxes(finish = false) {
        const wrapper = document.querySelector(".js-map-wrapper-locations");
        const fragment = document.createDocumentFragment();

        if (finish) {
            const div = document.createElement("div");
            div.innerHTML = this.html;

            fragment.append(div);
            wrapper.innerHTML = "";
            wrapper.append(fragment);

            SwiperCarousel.init();
            this.loadImages();

            _.defer(() => {
                this.updateView();
            });

            return true;
        }

        for (let index = 0; index < this.data.length; index++) {
            if (this.data[index]) {
                const location = this.data[index];
                let locationHtml;
                _.delay(
                    () => {
                        locationHtml = cardHTML(location);
                        if (!locationHtml) return;
                        this.html += locationHtml;

                        if (index + 1 == this.data.length) {
                            this.insertBoxes(true);
                        }
                    },
                    1000,
                    true
                );
            }
        }
    },

    /**
     * Center Map
     */
    centerMap() {
        getNearestPlaces().then((places) => {
            this.nearestPlaces = places.locations_without_custom;

            if (this.market) {
                this.map.flyTo({
                    center: [this.data[0].longitude, this.data[0].latitude],
                    zoom: mapZoom,
                });
            } else {
                this.map.flyTo({
                    center: [this.nearestPlaces[0].lng, this.nearestPlaces[0].lat],
                    zoom: 8,
                });
            }
        });
    },

    /**
     * Load Images
     */
    loadImages() {
        const images = document.querySelectorAll(".js-lazy-load-image[data-src]");

        if (images) {
            images.forEach((img) => {
                img.setAttribute("src", img.getAttribute("data-src"));
            });
        }
    },

    /**
     * Add Control
     */
    addControl() {
        this.map.addControl(new mapboxgl.NavigationControl(), "top-left");
    },

    /**
     * Update count
     */
    updateCount() {
        this.inBoundsLocations = _.uniq(this.inBoundsLocations);

        if (this.inBoundsLocations.length) {
            this.countLocations.parentNode.classList.remove(this.class);
        } else {
            this.countLocations.parentNode.classList.add(this.class);
        }

        this.countLocations.innerText = this.inBoundsLocations.length;
    },
};

induMap.init();
